import { BlockDataForm } from '@plone/volto/components/manage/Form';
import PropTypes from 'prop-types';

import { agendaSummarySchema } from './schema';

const AgendaSummaryData = (props) => {
  const { block, blocksErrors, data, onChangeBlock } = props;
  const schema = agendaSummarySchema(props);

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeBlock={onChangeBlock}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
      errors={blocksErrors}
    />
  );
};

AgendaSummaryData.propTypes = {
  block: PropTypes.string,
  blocksErrors: PropTypes.array,
  data: PropTypes.object,
  onChangeBlock: PropTypes.func,
};

export default AgendaSummaryData;
